import { Button, Skeleton, DatePicker, Card, Spin, ConfigProvider } from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  generatedISOFormatDateString,
} from "../../../../../../Utils/DateConverstion";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import TreeSelectCustomWithSelectAll from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
import TreeSelectCustom from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import * as echarts from 'echarts';
import * as XLSX from "xlsx";
import SteamTreeSelectCustom from "../../../../../Elements/TreeSelect/TreeSelectCustom";
import {
  FilterOutlined,
   } from "@ant-design/icons";
import Empty from "../../../../../CommonScreens/Empty";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
 
const ElectricalHistoricalTrends = () => {
  const chartRef = useRef(null);  
  const {loading,  makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState();
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]); 
  const [selectedValues, setSelectedValues] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false); 
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState(); 
  const [chartSkip, setChartSkip] = useState(true);

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [chartLoading, setChartLoading] = useState(false);
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [value, setValue] = useState([null, null]);

  const [steamHistoricalData,setsteamHistoricalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [parameter,setParameter]=useState([]);
  const [data1,setData1]= useState([]);
  const [data2,setData2]= useState([]);
  const [data3,setData3]= useState([]);
  const [parameterLenght, setParameterLenght] = useState('')
  const defaultParameters = ['kWhImport','KWT','IAVG','VLLAvg'];
  const [loadings, setLoadings] = useState(true);
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 2000); // 2 seconds
  };
  useEffect(()=>{
    simulateLoading(setLoadings);
  },[])


  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  console.log(color)
   useEffect(() => {
      document.documentElement.style.setProperty("--date-ok-btn", color.themeConfig.colorPrimary);
      document.documentElement.style.setProperty("--date-now-btn", "#fff");
    }, [color]);

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET, 
        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        if(res&&res.length>0){
          
          setflowSectionResData(res);
        }
      });

    makeRequest({ 
        type: APIConstants.GET, 
        url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        if(res&&res.length>0){
          
          setgetFlowConverterResData(res);
        }
      });

    makeRequest({  
       type: APIConstants.POST,
       url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
      }).then((res) => {
        console.log(res)
        if(res&&res.length>0){
          setflowGroupDetailsResData(res);
        }
      });
      makeRequest({  
        type: APIConstants.GET, 
        url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`
      }).then((res) => {
        console.log(res)
        if(res&&res.length>0){
          
          setParameter(res);
        }
      });
   
  },[])

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET,  
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}` 
      }).then((res) => {
        console.log(res) 
        if(res&&res.length>0){
          
          setnsGetFlowConverterResData(res);
        }
      });

    makeRequest({ 
        type: APIConstants.POST,  
        url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`
      }).then((res) => {
        console.log(res)
        if(res&&res.length>0){
          
          setgetFlowSteamGroupMeterResData(res);
        }
      });
  },[converterGroupId])
 
  
  function transformDatas(inputData) {
    // Initialize arrays to store unique CreatedOn values and unique meter names
    const createdOn = [];
    const meterNames = [];
    
    // Collect unique CreatedOn values and meter names
    inputData.forEach(entry => {
      const formattedDate = entry.CreatedOn.replace("T", " ");
      if (!createdOn.includes(formattedDate)) {
        createdOn.push(formattedDate);
      }
      if (!meterNames.includes(entry.METERNAME)) {
        meterNames.push(entry.METERNAME);
      }
    });
  
    // Initialize series array with meter names
    const series = meterNames.map(meterName => ({
      name: meterName,
      type: 'line',
      stack: 'Total',
      data: Array(createdOn.length).fill(0) // Initialize with zeros for each CreatedOn value
    }));
  
    inputData.forEach(entry => {
      const formattedDate = entry.CreatedOn.replace("T", " ");
      const dateIndex = createdOn.indexOf(formattedDate);
      const meterIndex = meterNames.indexOf(entry.METERNAME);
  
      if (dateIndex !== -1 && meterIndex !== -1) {
        series[meterIndex].data[dateIndex] += entry.KWHTotal;
      }
    });
  
    // Return the formatted structure
    return { series, createdOn, meterNames };
  }
  

function prepareLineChartData(data, excludeFields = ["SiteName", "MeterId", "CreatedOn", "METERNAME"]) {
  const series = [];
  const xAxisData = [];
  const metrics = {};
  const parameters=[];
  
  function removeDuplicates(inputArray) {
    console.log(inputArray)
    const seen = new Set();
    const result = [];
    
    inputArray.forEach(item => {
      if (!seen.has(item)) {
        result.push(item); 
        seen.add(item);
      }
    });
     
    return result;
  }

  data.forEach((entry) => {
      // Add unique timestamps to x-axis  
      if (!xAxisData.includes(entry.CreatedOn.replace("T", " "))) {
          xAxisData.push(entry.CreatedOn.replace("T", " ")); 
      }

      // Iterate through all fields in the entry
      for (const key in entry) {
          if (!excludeFields.includes(key)) {
              // Group by METERNAME and metric (e.g., KWHTotal)
              const metricKey = `${entry.METERNAME}-${key}`;
              if (!metrics[metricKey]) {
                  metrics[metricKey] = [];
              }
              metrics[metricKey].push(entry[key]);
              parameters.push(key);

          }
      }
  });

  // Prepare series for ECharts
  for (const [metricName, values] of Object.entries(metrics)) {
      series.push({
          name: metricName,
          type: 'line',
          data: values, 
      });
  }
  const para = removeDuplicates(parameters);
  console.log(para);
  console.log(xAxisData);
  const uniqueTimestamps = Array.from(
    new Set(xAxisData.map(ts => {
      const [date, time] = ts.split(' '); // Split date and time
      const timeWithoutSeconds = time.split(':').slice(0, 2).join(':'); // Keep hour and minute
      return `${date} ${timeWithoutSeconds}:00`; // Append :00 for seconds
    }))
  );

  console.log(uniqueTimestamps)
  // Return the chart configuration

  return {
      xAxisData:uniqueTimestamps,
      series: series,
      parameter:para
  };
}

  
  const getResponse =(inputData)=>{
    console.log(inputData);
    setIsLoading(true);
    
    makeRequest({ 
        type: APIConstants.GET,  
        url: `${APIConstants.ELECTRICAL_HISTORICAL_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}` 
      }).then((res) => {
        console.log(res)
        setsteamHistoricalData(res);
        if (res&&res.length>0) {    
          const data = transformDatas(res);
          console.log(data)
          console.log(data.meterNames)
          // setData1(data.createdOn) 
          // setData2(data.series)
          // setData3(data.meterNames)
          const test =prepareLineChartData(res)
          console.log(test)
          setData1(test.xAxisData)
          setData2(test.series)
          // setData3(test.parameter)
        }
        setIsLoading(false);
      });
  }
 
  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values.length>4) {
      console.log(values);
      setParameterLenght('Cannot select more than 4 values');
    }else{
      setParameterLenght('');
    }
    if (values) {
      setParaError("");
    }
  };

  const setChartInputData = () => {
    const ids = selectedMeterIds?.map((id) => id).join(",");
    const para = selectedValues?.map((id) => id).join(",");
    console.log(para)

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const formattedFromDate = generatedISOFormatDateString(fromDate);
    const formattedToDate = generatedISOFormatDateString(toDate);

    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 1,
      Parameters:para||0,
      MeterIds: ids || [1],
      FromDate: formattedFromDate,
      ToDate: formattedToDate,
    };
    console.log(inputData)
    getResponse(inputData);
  };

  useEffect(() => {
    setChartInputData();
  },[]);
 
  useEffect(() => {
    setChartSkip(!chartSkip);
    updateChart();
  },[steamHistoricalData]);
 
  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds.length, "Meter");
    const paraError = validateInput(selectedValues.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError); 
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError 
      // &&
      // !fromDateError &&
      // !toDateError 
      // && !parameterLenght
    ) {
      onClose();
      setChartLoading(true);
      setChartInputData();
      
      setIsLoading(true); 
    }
  };

  const onChangeFromDate = ( dateString) => {
    setFromDateString(dateString);
    setFromDateObj(dateString);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = ( dateString) => {
    setToDateString(dateString);
    setToDateObj(dateString);
    if (dateString) {
      setToDateError("");
    }
  };

  const updateChart = async () => { 
    try {
      setChartLoading(true);
  
      // Filter steamHistoricalData based on selected meter IDs
      const selectedMeterData = steamHistoricalData?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item?.meterId)
      );
  
      // Transform the data in a chart series format
      const transformData = (parameterName, meterName) => {
        const data = selectedMeterData
          ?.filter((item) => item?.sitename === meterName)
          ?.map((item) => item[parameterName]);
        return {
          name: `${parameterName}-${meterName}`,
          data,
        };
      };
  
      const seriesData = [];
      console.log(selectedValues)
      console.log(nsGetFlowConverterList)
  
      // Iterate over selected meter IDs and selectedValues properties
      selectedMeterIds?.forEach((id) => {
        const meterName = sectionId === 1
          ? nsGetFlowConverterList?.find((item) => item?.meterid === Number(id))?.metername
          : getFlowSteamGroupMeterList?.find((item) => item?.meterID === Number(id))?.meterName;
          console.log(meterName)
  
        selectedValues.forEach(({ parametername }) => {
          seriesData.push(transformData(parametername, meterName));
        });
      });

      console.log(selectedValues)
      console.log(seriesData)
  
      const datesArray = [];
      const dateProperty = "createdOn";
      
      selectedMeterIds?.forEach((id) => {
        const meterName = sectionId === 1
          ? nsGetFlowConverterList?.find((item) => item?.meterid === Number(id))?.metername
          : getFlowSteamGroupMeterList?.find((item) => item?.meterID === Number(id))?.meterName;
          
        datesArray.push(transformData(dateProperty, meterName));
      });
  
      // Filter to include only selected parameter names in selectedValues
      const finalData = seriesData.filter((series) => 
        selectedValues.some(({ parametername }) => series.name.includes(parametername))
      );
  
      // Find the longest date array and reverse it
      const reversedDate = datesArray.reduce((largest, current) => {
        if (!largest || current.data.length > largest.data.length) {
          return { ...current, data: [...current.data].reverse() };
        }
        return largest;
      }, null);
  
      const reversedFinalData = finalData.map((data) => ({
        data: data.data.reverse(),
        name: data.name,
      }));
  
      // Format dates for x-axis
      const localDateTime = reversedDate?.data?.map((date) =>
        new Date(date).toLocaleString("en-US")
      );
      console.log(reversedFinalData)
  
      // setData1(reversedFinalData);
      // setData2(localDateTime);
  
      setChartLoading(false);
    } catch (err) {
      console.error(err);
      setChartLoading(false);
    }
  };


const exportToExcel = (data) => {
  if (!Array.isArray(data) || data.length === 0) return;

  // Get the maximum data length among all series
  const maxRows = Math.max(...data.map(item => item.data.length));

  // Header row: ["S. No.", "DG Incomer", "SolarOutput", ...]
  const headers = ["S. No.", ...data.map(item => item.name)];

  // Build the rows dynamically, allowing for different data lengths
  const rows = Array.from({ length: maxRows }, (_, i) => {
    const row = [`${i + 1}`];
    for (const item of data) {
      row.push(item.data[i] !== undefined ? item.data[i] : ""); // Handle missing values
    }
    return row;
  });

  const excelData = [headers, ...rows];

  // Create a new workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(excelData);

  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "EnergyData");

  // Generate a filename with timestamp
  const now = new Date();
  const timestamp = now.toLocaleString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }).replace(/[/,: ]/g, "-");

  const filename = `Historical_Trends_${timestamp}.xlsx`;

  // Export the file
  XLSX.writeFile(workbook, filename);
}; 
  
    //  useEffect(() => {
    //     if (selectedValues.length === 0) {
    //       setSelectedValues(defaultParameters); 
    //     }
    //   }, [selectedValues]);
  
  useEffect(() => {
    if (loading || !data1 || !data2) return; // Prevent chart rendering if loading or data is unavailable
  
    console.log(data1);
    console.log(data2);
  
    const myChart = echarts.init(chartRef.current);
  
    const option = { 
      // backgroundColor: isdarkMode ? '#2d3748' : '#ECFDF3', 
      backgroundColor: isdarkMode ? '#2d3748' : color.themeConfig.colorPrimaryShade,

      // title: {
      //   text: `Historical Trends`,
      //   left: 'center',
      //   top: '5px',
      //   textStyle: {
      //     color: isdarkMode ? 'white' : 'black',
      //   },
      // },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        confine: true, 
        position: function (point, params, dom, rect, size) {
          // `point` is the mouse position, `[x, y]`
          // `size` contains the size of the tooltip
          const [x, y] = point;
          const { contentSize, viewSize } = size; // Size of the tooltip and view
      
          let xPos = x + 10; // Add some padding
          let yPos = y + 10;
      
          // Prevent overflow on the right
          if (xPos + contentSize[0] > viewSize[0]) {
            xPos -= contentSize[0] + 20; // Move it left
          }
      
          // Prevent overflow on the bottom
          if (yPos + contentSize[1] > viewSize[1]) {
            yPos -= contentSize[1] + 1000; // Move it up
          }
      
          return [xPos, yPos];
        },
      },
      
      legend: {
        bottom: '0px',
        textStyle: {
          color: isdarkMode ? 'white' : 'black',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '25%', 
        containLabel: true,
      },
      toolbox: {
        show: true,
        orient: 'horizontal',
        left: 'right',
        top: 'top',
        feature: {
          myExport: {
            show: true,
            title: "Export to Excel",
            icon: "path://M5 0L15 10L5 20Z", 
            onclick: () => {
              exportToExcel(data2);
            },
          },
          mark: { show: true },
          magicType: { show: true, type: ['line', 'bar'] },
          saveAsImage: { show: true },
        },
        iconStyle: {
          borderColor: isdarkMode ? 'white' : 'black',
        },
        emphasis: {
          iconStyle: {
            borderColor: isdarkMode ? '#FFD700' : '#1E90FF', 
          },
        },
      },
      xAxis: [
        {
          type: 'category',
          data: Array.from({ length: 8 }, (_, i) => `S. No.${i + 1}`), // Example categories
          axisTick: { show: false },
          data: data1,
          axisLabel: {
            color: isdarkMode ? 'white' : 'black',
            fontSize: '10',
            fontWeight: 'bold',
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            color: isdarkMode ? 'white' : 'black',
            fontSize: '10',
            fontWeight: 'bold',
          },
        },
      ],
      series: data2,
      dataZoom: [
        {
          type: 'inside', // Enables zooming via scroll or pinch
          start: 0,
          end: 100,
        },
      ],
    };
    
  
    myChart.setOption(option);
  
    const resizeHandler = () => myChart.resize();
    window.addEventListener('resize', resizeHandler);
  
    return () => {
      window.removeEventListener('resize', resizeHandler);
      myChart.dispose();
    };
  }, [data1, data2, isdarkMode, loading,color]); // Include loading in dependencies
  
 
   const today = dayjs();
    const startOfWeek = dayjs().weekday(0); // Sunday
    const endOfWeek = dayjs().weekday(6);   // Saturday
    const startOfLastWeek = dayjs().subtract(1, "week").weekday(0);
    const endOfLastWeek = dayjs().subtract(1, "week").weekday(6);
    const startOfMonth = dayjs().startOf("month");
    const endOfMonth = dayjs().endOf("month");
    const startOfLastMonth = dayjs().subtract(1, "month").startOf("month");
    const endOfLastMonth = dayjs().subtract(1, "month").endOf("month");
    
    const rangePresets = [
      // { label: "Today", value: [today.startOf("day"), today.endOf("day")] },
      // { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.subtract(1, "day").endOf("day")] },
      { label: "This Week", value: [startOfWeek, endOfWeek] },
      { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
      { label: "This Month", value: [startOfMonth, endOfMonth] },
      { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
      { label: "Last 7 Days", value: [dayjs().subtract(7, "day"), today] },
      { label: "Last 14 Days", value: [dayjs().subtract(14, "day"), today] },
      { label: "Last 30 Days", value: [dayjs().subtract(30, "day"), today] },
      { label: "Last 90 Days", value: [dayjs().subtract(90, "day"), today] },
    ];
    const handleDateChange = (value) => {
      if (!value) return;
      const diff = value[1]?.diff(value[0], "day");
  
      if (diff > MAX_DAYS) {
        alert("Date range cannot exceed 90 days");
        return;
      }
      
      if (value) {
        // const fromDate = value[0];
        // const toDate = value[1];
        const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
        const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");
  
        console.log([fromDate, toDate]);
      setValue([value[0], value[1]]);
        onChangeFromDate(fromDate);
        onChangeToDate(toDate);
      } else {
        // setDates(null);
      }
    };
  return (
    <div id="chart" className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode '} `}>

       <div className="flex justify-between items-center px-0 pb-4">
        <div className="text-3xl">
          <p
            className={` dark ${isdarkMode ? "darkfont" : "whitemode"} text-center pb-0  ml-0 font-[500] tracking-[1px]`}
          >
            HISTORICAL TRENDS 
          </p>
        </div>
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
          style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}
            onClick={() => setOpen(!open)}
          >
            <FilterOutlined /> Filter
          </Button>
      </div>
      {loading  && ( 
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}
      <Card 
        className={`p-4 rounded-md dark  ${!data1.length>0?"hidden":""}  ${isdarkMode ? "darkmode" : "whitemode bg-[#ECFDF3]"} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{ position: "relative", overflow: "hidden", background:isdarkMode ? "" : color.themeConfig.colorPrimaryShade }}
      >  
{
          !data1.length >0 && !loading &&
          <Empty open={open}  setOpen={setOpen} isdarkMode={isdarkMode} />
          // <div className="text-3xl">
          // <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
          // </div> 
         } 
        
        <div ref={chartRef} className={`${(!loading||!loadings) && data1.length>0 ? 'min-h-[80vh]':'h-0'}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}/>

        </Card>


        
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustom
            label="Parameters:"
            data={parameter}
            idKey="id"        
            nameKey="name"     
            valueKey="name" 
            // <SteamTreeSelectCustom
            // label="Parameters:"
            // data={parameter}
            // idKey="parameterid"
            // nameKey="parametername"
            // valueKey="parameterid"
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
            {/* {parameterLenght} */}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">Date:</label>
            <RangePicker
      value={value}
      onChange={handleDateChange}
      popupClassName="custom-picker"
      presets={rangePresets}
      format="YYYY-MM-DD HH:mm:ss"
      showTime={{ format: "HH:mm:ss" }}
      className={`w-80 ml-0 shadow-lg rounded-3xl  ${
        isdarkMode
          ? "customRangePicker-dark  text-white"
          : "customRangePicker-light text-black"
      }`}
      panelRender={(originalPanel) => {
        if (!showCalendar) {
          return (
            <div
              className={`${
                isdarkMode ? "bg-[#1a1a1a]" : "bg-white"
              } flex flex-col gap-1 p-2 w-44 rounded`}
            >
              {rangePresets.map((preset) => (
                <div
                  key={preset.label}
                  onClick={() => handleDateChange(preset.value)}
                  className={`cursor-pointer px-2 py-1 rounded ${
                    isdarkMode
                      ? "text-white hover:bg-gray-700"
                      : "text-black hover:bg-gray-200"
                  }`}
                >
                  {preset.label}
                </div>
              ))}
              <button
                onClick={() => setShowCalendar(true)}
                className={`mt-2 px-2 py-1 rounded  border text-center ${
                  isdarkMode
                    ? "bg-[#1a1a1a] border-white text-white hover:bg-gray-700"
                    : "bg-white border-black text-black hover:bg-gray-200"
                }`}
              >
                Custom Dates
              </button>
            </div>
          );
        }
        return originalPanel;
      }}
      onOpenChange={(open) => {
        if (!open) setShowCalendar(false);
      }}
    />
            {/* <DatePicker
              value={fromDateObj}
              onChange={onChangeFromDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
              popupClassName="custom-picker"
            /> */}
          </div>
          {/* <small className="text-red-500 font-bold ml-[150px]">
            {fromDateError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">To Date:</label>
            <DatePicker
              value={toDateObj}
              onChange={onChangeToDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
              popupClassName="custom-picker"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {toDateError}
          </small> */}
        </div>
        <div className="flex justify-center mt-4">
                      <Button
                        type= {isdarkMode? "":'primary'}
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Search
                      </Button>
        </div>
      </CustomDrawer>
      <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
          .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
    </div>
  );
};

export default ElectricalHistoricalTrends;
